import {PaymentMethodType} from "@app/core/delivery-point/application/dtos/payment-method-type";

const KEY_VISA = 'VISA';
const KEY_COHAB = 'COHAB';
const KEY_BIZUM = 'BIZUM';
const KEY_GOOGLE_PAY = 'GOOGLE_PAY';
const KEY_APPLE_PAY = 'APPLE_PAY';

export class PaymentMethodTypeMapper {
    static deserialize(value: string): PaymentMethodType {
        switch (value) {
            case KEY_VISA:
                return PaymentMethodType.VISA;
            case KEY_COHAB:
                return PaymentMethodType.USUAL_CONDITIONS;
            case KEY_BIZUM:
                return PaymentMethodType.BIZUM;
            case KEY_GOOGLE_PAY:
                return PaymentMethodType.GOOGLE_PAY;
            case KEY_APPLE_PAY:
                return PaymentMethodType.APPLE_PAY;
            default:
                return PaymentMethodType.UNKNOWN;
        }
    }

    static serialize(value: PaymentMethodType): string {
        switch (value) {
            case PaymentMethodType.VISA:
                return KEY_VISA;
            case PaymentMethodType.USUAL_CONDITIONS:
                return KEY_COHAB;
            case PaymentMethodType.BIZUM:
                return KEY_BIZUM;
            case PaymentMethodType.GOOGLE_PAY:
                return KEY_GOOGLE_PAY;
            case PaymentMethodType.APPLE_PAY:
                return KEY_APPLE_PAY;
            default:
                throw new Error(`Unknown payment method type: ${value}`);
        }
    }

}
